module.exports = __webpack_public_path__ + "img/card_menu_icon.595509fd.svg";